import type { IEditor } from 'roosterjs-editor-types';

const STRIP_ZERO_WIDTH_CHARACTERS_REGEX = /[\u200B-\u200D\uFEFF]/g;
const NON_BREAKING_SPACE_REGEX = /[\xC2\xA0]/g;
const SINGLE_SPACE = ' ';
const MAX_CHARS_FOR_CHARACTERS_BEFORE_CURSOR = 300;
const BODY_LENGTH = 4000;

export default function getCharactersBeforeCursor(editor: IEditor): string {
    if (editor) {
        let content: string = '';

        // First get the characters immediately before the cursor.
        // The content searcher that we get from editor.getContentSearcherOfCursor only returns the characters
        // before the cursor within the current block
        const searcher = editor.getContentSearcherOfCursor();
        if (searcher) {
            content = searcher.getSubStringBefore(MAX_CHARS_FOR_CHARACTERS_BEFORE_CURSOR);
        }

        // In order to get more text (beyond the current block element) use a body traverser starting at the
        // current block element and walk backwards adding on all of the text in each preceeding block element
        // until we get (roughly) to the numberOfCharactersToGet
        const blockTraverser = editor.getBlockTraverser();
        let currentBlockElement = blockTraverser?.currentBlockElement;
        if (currentBlockElement) {
            const bodyTraverser = editor.getBodyTraverser(currentBlockElement.getStartNode());
            while (content.length < BODY_LENGTH) {
                // Here the bodyTraverser iterates though the block elements updating its internal state with the block
                // element we're currently inspecting.
                // Get the previouse BlockElement from the body if possible or null if we're at the beginning already
                currentBlockElement = bodyTraverser.getPreviousBlockElement();
                if (!currentBlockElement) {
                    break;
                }

                const textContent = currentBlockElement.getTextContent();
                if (textContent) {
                    content = textContent + '\n' + content;
                }
            }
        }

        content = content.replace(STRIP_ZERO_WIDTH_CHARACTERS_REGEX, '');
        content = content.replace(NON_BREAKING_SPACE_REGEX, SINGLE_SPACE);
        return content;
    }

    return '';
}
